// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__bzQCb","h2":"Heading_h2__IiqqI","h3":"Heading_h3__gXFUk","h4":"Heading_h4__IYKmz","h5":"Heading_h5__UdDvq","h6":"Heading_h6__owYYL"};